import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  Grid,
  Chip,
  Divider,
  Tab,
  Tabs,
} from "@mui/material"; 
import OfferIndividualTableList from "./OfferIndividualTableList";
import TrackingOfferList from "./TrackingOfferList";

const OfferIndividual = () => {
  const { id } = useParams();
  console.log(id);
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [newloading, setnewLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  // offer/promocode/user

  useEffect(() => {
    fetchOfferDetails();
    fetchData(id, currentPage);
    fetchTarckingCoupons(id);
    // fetchOfferpromocedeDetails()
  }, [id, currentPage]);

  // Offer promocode fetch data

  const fetchData = async (id, page) => {
    setnewLoading(true);
    try {
      const { data } = await axios.get(
        `https://api.medstown.com/offer/promocode/user/${id}?page=${page}`
      );
      setData(data.data);
      setTotalPages(Math.ceil(data.data.totalPages / 10));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setnewLoading(false);
    }
  };

  const fetchOfferDetails = async () => {
    try {
      const response = await axios.get(
        `https://api.medstown.com/offer/promocode/${id}`
      );

      setOffer(response.data.data);
    } catch (error) {
      console.error("Error fetching offer details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTarckingCoupons = async (id) => {
    setnewLoading(true);
    try {
      const { data } = await axios.get(
        `https://api.medstown.com/offer/coupons/tracking/${id}?page=${currentPage}`
      );
      setData(data.data);
      console.log(data.data);
      setTotalPages(Math.ceil(data.data.totalPages / 10));
    } catch (error) {
      console.error("Error fetching tracking coupons:", error);
    } finally {
      setnewLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!offer) {
    return (
      <Typography variant="h6" align="center" color="error">
        Offer not found
      </Typography>
    );
  }

  return (
    <>
      <Box display="flex" gap={2} px={2}>
        <Card
          sx={{
            flex: "0 0 20%",
            height: "150px",
            p: 2,
            mt: 4,
            mb: 5,
            borderRadius: 5,
            textAlign: "center",
          }}
        >
          {data.totalCount > 0 ? (
            <Typography variant="subtitle1" mt={1}>
              Users have used the coupon 🎉
            </Typography>
          ) : (
            <Typography variant="body2" mt={1} color="text.secondary">
              No users have used the coupon yet 😔
            </Typography>
          )}

          <Box fontSize={28} fontWeight="bold" color="primary.main">
            {data.totalCount > 0 ? data.totalCount : 0}
          </Box>
        </Card>
        <Card sx={{ flex: "1 1 80%", p: 2, mt: 4, mb: 5, borderRadius: 5 }}>
          <CardContent>
            {/* <Typography
              variant="h5"
              sx={{ fontWeight: "bold", textAlign: "center", mb: 2 }}
            >
              {offer.code}
            </Typography> */}

            {/* Partner Details */}
            {/* {offer.collabrate_partner?.title && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mb={3}
                p={2}
                borderRadius={2}
                border={"1px solid #ddd"}
                bgcolor="white"
              >
                <Box
                  component="img"
                  src={offer.collabrate_partner.img_url}
                  alt={offer.collabrate_partner.title}
                  sx={{
                    width: 100,
                    height: 80,
                    borderRadius: "8px",
                    objectFit: "cover",
                    border: "1px solid #ddd",

                    transition: "transform 0.3s",
                    "&:hover": { transform: "scale(1.05)" },
                  }}
                // onError={(e) => {
                //   e.target.onerror = null;
                //   e.target.src = "/";
                // }}
                />

                <Typography
                  variant="h6"
                  fontWeight="bold"
                  mt={1}
                  textAlign="center"
                >
                  {offer.collabrate_partner.title}
                </Typography>
              </Box>
            )} */}
            {}
            {/* Offer Type */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Coupon Code :</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">{offer.code}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Coupon Status :</Typography>
              </Grid>
              <Grid item xs={6}>
                {/* Offer Status */}
                <Typography
                  variant="body2"
                  sx={{
                    color: offer.is_live ? "green" : "red",
                    fontWeight: "bold",
                    // textAlign: "center",
                  }}
                >
                  {offer.is_live ? "Active" : "Inactive"}
                </Typography>
              </Grid>

              {offer.collabrate_partner?.title && (
                <>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2">
                      Collabrater Partner :
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2">
                      {offer.collabrate_partner?.title}
                    </Typography>
                  </Grid>
                </>
              )}

              <Grid item xs={6}>
                <Typography variant="subtitle2">Discount Type:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Chip
                  label={
                    offer.discount_type === "fixedPrice"
                      ? "Fixed Price"
                      : "Percentage"
                  }
                  color="primary"
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2">Discount Value:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">
                  {offer.discount_type === "fixedPrice"
                    ? `₹${offer.fixedPrice}`
                    : `${offer.discount}% (Max ₹${offer.max_discount_amount})`}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Minimum Bill Amount:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">
                  ₹{offer.minimum_bill_amount}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2">Valid Until:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">
                  {new Date(offer.valid_until).toLocaleDateString("en-GB")}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2">Number of Uses:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">{offer.number_of_uses}</Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Description */}
            <Typography variant="body2" sx={{ fontStyle: "italic" }}>
              {offer.description}
            </Typography>
          </CardContent>
        </Card>
      </Box>
      <Box>
        {/* <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", mt: 4 }}> */}
        <Tabs
          value={tabIndex}
          onChange={(e, val) => setTabIndex(val)}
          variant="fullWidth"
          sx={{
            mb: 2,
            borderRadius: 2,
            backgroundColor: "#f0f0f0",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              color: "#555",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            },
            "& .Mui-selected": {
              color: "#fff !important",
              backgroundColor: "#1976d2 !important",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab label="Coupon Usage History" />
          <Tab label="Unredeemed Coupons" />
        </Tabs>

        <Box>
          {tabIndex === 0 && (
            <OfferIndividualTableList
              id={id}
              data={data}
              setData={setData}
              totalPages={totalPages}
              setTotalPages={setTotalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              newloading={newloading}
              setnewLoading={setnewLoading}
            />
          )}
          {tabIndex === 1 && <TrackingOfferList id={id} />}
        </Box>
      </Box>

      <Box p={2}>
        {/* {tabIndex === 0 && (
          
          )} */}
        {/* {tabIndex === 1 && <Typography>Dummy Table Content</Typography>} */}
      </Box>
      {/* </Box> */}
    </>
  );
};

export default OfferIndividual;
